/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import { SearchUI } from "components/search/SearchUI";
import { getShowSearchInputUI, enableSearchUI } from "selectors/searchSelectors";
import { isSearchFeatureEnabled } from "selectors/appSelectors";
import { getViewMode } from "selectors/viewModeSelectors";
import { isSinglePageMode } from "selectors/documentSelectors";
import { isControlORCommandPressed } from "dc-preview-utils/src/Utils/EventHandlingUtils";
import { F, F3 } from "dc-preview-utils/src/Constants/key-codes";

const mapStoreToProps = stores => ({
  showSearchInputUI: getShowSearchInputUI(stores),
  enableSearchFeature: isSearchFeatureEnabled(stores),
  isSinglePageMode: isSinglePageMode(stores),
  onKeyDown: event => {
    switch (event.keyCode) {
      case F:
        if (isControlORCommandPressed(event)) {
          if (enableSearchUI(stores)) {
            event.preventDefault();
            stores.searchStore.setShowSearchInputUI(true, getViewMode(stores));
          }
        }
        break;
      case F3:
        if (enableSearchUI(stores)) {
          event.preventDefault();
          stores.searchStore.setShowSearchInputUI(true, getViewMode(stores));
        }
        break;
      default:
        break;
    }
  }
});

const SearchUIContainer = inject(mapStoreToProps)(SearchUI);

SearchUIContainer.propTypes = {
  options: PropTypes.shape({
    color: PropTypes.string.isRequired
  })
};

SearchUIContainer.defaultProps = {
  options: {
    color: "light"
  }
};

export { SearchUIContainer };
